import React from 'react';
export const DeleteAccount = React.lazy(() => import('./DeleteAccount.jsx'));
